import { compose } from 'recompose';
import _property from 'lodash/property';

// Readers
import filterTypeReader from '../readers/FilterType';
export var getOptionsFromFilter = compose(_property('options'), filterTypeReader.additional);
export var getDefaulPresetFromFilter = compose(_property('defaultPreset'), filterTypeReader.additional);
export var getFilterOptionFromFilter = compose(_property('filterOption'), filterTypeReader.additional);
export var getOperatorFromFilter = compose(_property('operators'), filterTypeReader.additional);
export var getOverlayPlaceholder = compose(_property('overlayPlaceholder'), filterTypeReader.additional);
export var getErrorFromFilter = compose(_property('error'), filterTypeReader.additional);
export var getSortPropFromFilter = compose(_property('sort'), filterTypeReader.additional);
export var getShouldSortOptions = compose(_property('shouldSortOptions'), filterTypeReader.additional);
export var shouldShowSelectAll = compose(_property('showSelectAll'), filterTypeReader.additional);